import React from 'react';
import DatabaseContext from '../context/DatabaseContext';

export default function (SubscriberComponent) {
    return function(props) {
        return(
            <DatabaseContext.Consumer>
                {
                    rtd => (
                        <SubscriberComponent
                            reference={rtd.ref('users')}
                            {...props}/>
                    )
                }
            </DatabaseContext.Consumer>
        );
    };

}


// WEBPACK FOOTER //
// ./src/consumers/users.js